import React from 'react';
import { motion } from 'framer-motion';

const Card = ({ children, className = '' }) => {
  return (
    <div className={`db-card ${className}`}>
      {children}
    </div>
  );
};

export default Card;
